import { Channels } from '@/core/constants/channelConstants';
import { Roles } from '@/core/constants/roleConstants';
import { BasePolicy } from '../BasePolicy';

export class VisorPolicy extends BasePolicy {
  static canList() {
    const roles = [Roles.PRESIDENCY];

    const channels = [Channels.WHOLESALER, Channels.RETAIL];

    return this.hasAnyRole(roles) && this.hasAnyChannel(channels);
  }
}
